import React, { Component } from "react";
import Modal from "../components/Modal";
import StagesManager from "../components/StagesManager";
import AddUserForm from "./AddUser/AddUserForm";
import AddUserHome from "./AddUser/AddUserHome";
import AddUserSearch from "./AddUser/AddUserSearch";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';

class AddUserModal extends Component {

  state = {
    // isLoadingRemove: false,
    id: null,
    index: null,
    data: {}
  }

  hideModal = (id, index) => {
    this.modal.hideModal()
  }

  showModal = (edit) => {
    this.setState({ edit, data: this.props.initData }, () => {
      this.modal.showModal()
      setTimeout(() => {
        this.initPage(edit)
      }, 10);
    })
  }

  initPage = (edit) => {
    if (edit) {
      this.stagesManager.changeStage("form", null, null, true)
    } else {
      this.stagesManager.changeStage("home", null, null, true)
    }
  }

  // hideModal = () => {
  //   this.removeModal.hideModal()
  // }

  onDone = (type) => {
    this.props.onDone(type)
    this.modal.hideModal()
  }

  changeStage = (key) => {
    if (this.stagesManager) {
      this.stagesManager.changeStage(key)
    }
  }

  setData = (data, cb) => {
    let newDate = this.state.data
    if (!newDate) {
      newDate = {}
    }
    if (data == null) {
      newDate = null
    } else {
      for (const [key, value] of Object.entries(data)) {
        newDate[key] = value
      }
    }
    this.setState({ data: newDate }, () => {
      if (cb) { cb() }
    })
  }

  stageChanged = (stage) => {
    this.setState({ currentStage: stage })
    if (this.container) {
      this.container.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  userInvited = (data) => {
    this.hideModal()
    this.props.itemAdded(data)
  }

  itemEdited = (data) => {
    this.hideModal()
    this.props.itemEdited(data)
  }

  render() {
    return (
      <Modal cancelModal={this.props.cancelModal} ref={el => this.modal = el} maxWidth={this.state.currentStage == 'form' ? 700 : 400} className="flexcc text-center">
        <div ref={el => this.container = el} className="w-100 h-100 " style={{ backgroundColor: '#fff', borderRadius: 8, overflow: 'auto', }}>
          <StagesManager ref={el => this.stagesManager = el} changeCB={this.stageChanged}>
            {/* <AddPermissionUsers stage={0} stageName="home" /> */}
            <AddUserHome stage={1} stageName="home" initData={this.state.data} onDone={this.onDone} setData={this.setData} changeStage={this.changeStage} colors={this.props.colors} />
            <AddUserSearch stage={1} stageName="search" initData={this.state.data} onDone={this.onDone} setData={this.setData} changeStage={this.changeStage} colors={this.props.colors} userInvited={this.userInvited} actions={this.props.actions} page={this.props.page} headers={this.props.headers} variables={this.props.variables} />
            <AddUserForm stage={1} stageName="form" initData={this.state.data} onDone={this.onDone} setData={this.setData} changeStage={this.changeStage} colors={this.props.colors} userInvited={this.userInvited} itemEdited={this.itemEdited} actions={this.props.actions} hideModal={this.hideModal} edit={this.state.edit} page={this.props.page} headers={this.props.headers} variables={this.props.variables} />
          </StagesManager>
        </div>
      </Modal >
    );
  }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null, { forwardRef: true }
)(AddUserModal);
